import {Component, EventEmitter, HostListener, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {GradientConfig} from '../../../../app-config';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit {
  public windowWidth: number;
  public gradientConfig: any;
  
  // @Output() onNavMobCollapse = new EventEmitter();
  isScreenAbove900: boolean = false;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.isScreenAbove900 = window.innerWidth > 900;
  }

  ngOnInit() {
    // Initialize the screen size when component loads
    this.isScreenAbove900 = window.innerWidth > 900;
  }
  constructor() {
    this.gradientConfig = GradientConfig.config;
    this.windowWidth = window.innerWidth;
  }



  // navMobCollapse() {
  //   console.log('Collapsee')
  //   if (this.windowWidth < 992) {
  //     this.onNavMobCollapse.emit();
  //   }
  // }

  // navFindCollapse(){

  // }
  @Input() showNavContent!: boolean;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['showNavContent']) {
      console.log("Nav Content Visibility in NavContent Component   okkk:", this.showNavContent);
    }
  }


}
